import { render, staticRenderFns } from "./Agent10XModal.vue?vue&type=template&id=d49841fa&scoped=true&"
import script from "./Agent10XModal.vue?vue&type=script&lang=ts&"
export * from "./Agent10XModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d49841fa",
  null
  
)

export default component.exports